module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5153/images/default-company-avatar.png"